import classNames from 'classnames';

import { NumberUtils } from '@/common/utils';

interface NumberWithUnitProps {
  amount: number | string | null | undefined;
  className?: string;
  option?: Intl.NumberFormatOptions;
  paddingBetweenAmountAndUnit?: boolean;
  unit?: string;
  unitClassName?: string;
}

export const NumberWithUnit = ({
  amount,
  className,
  option,
  paddingBetweenAmountAndUnit = false,
  unit,
  unitClassName,
}: NumberWithUnitProps) => {
  if (typeof amount === 'number' || typeof amount === 'string') {
    return (
      <span className={classNames(className, 'tabular-nums')}>
        {NumberUtils.format(amount, option)}
        {unit && (
          <span className={classNames(unitClassName, { 'ml-[15px] mr-[1px]': paddingBetweenAmountAndUnit })}>
            {!paddingBetweenAmountAndUnit ? ' ' : ''}
            {unit}
          </span>
        )}
      </span>
    );
  }

  return <></>;
};
